/* RNR Rug finder — BAVS 2026-08.
   Guided multi-step filter: builds a Search & Discovery filter URL on the
   results collection. Vanilla JS, no dependencies, mobile-first. */
(function () {
	'use strict';

	var root = document.querySelector('[data-rnr-finder]');
	var cfgEl = document.querySelector('[data-rnr-finder-config]');
	if (!root || !cfgEl) return;

	var cfg;
	try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

	var steps = cfg.steps;
	var stepEl = root.querySelector('[data-rnr-step]');
	var sideEl = root.querySelector('[data-rnr-sidebar]');
	var progEl = root.querySelector('[data-rnr-progress]');
	var backBtn = root.querySelector('[data-rnr-back]');
	var skipBtn = root.querySelector('[data-rnr-skip]');
	var nextBtn = root.querySelector('[data-rnr-next]');
	var browseA = root.querySelector('[data-rnr-browse]');

	var current = 0;
	var picked = {}; // stepKey -> object of optionKey -> true
	steps.forEach(function (s) { picked[s.key] = {}; });

	// Preselect from ?size=<presetKey>
	var qs = new URLSearchParams(window.location.search);
	var preset = qs.get('size');
	if (preset && cfg.presets && cfg.presets[preset]) {
		cfg.presets[preset].forEach(function (k) { picked.size[k] = true; });
		current = 1; // size already answered — start at material
	}

	function selectedCount(step) {
		return Object.keys(picked[step.key]).length;
	}

	function optionByKey(step, key) {
		for (var i = 0; i < step.options.length; i++) {
			if (step.options[i].key === key) return step.options[i];
		}
		return null;
	}

	function buildUrl() {
		var params = [];
		steps.forEach(function (s) {
			Object.keys(picked[s.key]).forEach(function (k) {
				var o = optionByKey(s, k);
				if (o) params.push(encodeURIComponent(s.param) + '=' + encodeURIComponent(o.value));
			});
		});
		return cfg.resultsUrl + (params.length ? '?' + params.join('&') : '');
	}

	function go(n) {
		current = Math.max(0, Math.min(steps.length - 1, n));
		render();
	}

	function finish() {
		window.location.href = buildUrl();
	}

	function toggle(step, key) {
		var fresh = selectedCount(step) === 0;
		if (picked[step.key][key]) {
			delete picked[step.key][key];
		} else {
			picked[step.key][key] = true;
		}
		render();
		// Uber-style snap: the very first pick on the size step advances on its own.
		if (step.key === 'size' && fresh && selectedCount(step) === 1) {
			window.setTimeout(function () {
				if (current === 0) go(1);
			}, 350);
		}
	}


	// ---- option imagery -------------------------------------------------
	// Priority: merchant override > bundled scene photo (the same room shots
	// the homepage size tiles use) > cached/live product photo (predictive
	// search) > true-scale size SVG > colour swatch.
	var overrides = cfg.overrides || {};

	function sizeSvg(o) {
		var L = Math.max(o.w, o.h), S = Math.min(o.w, o.h);
		var x = (380 - L) / 2, y = (250 - S) / 2;
		var body;
		if (o.round) {
			var r = S / 2;
			body = '<circle cx="190" cy="' + (y + r) + '" r="' + r + '" fill="#dac19f" stroke="rgba(70,45,25,.3)" stroke-width="1.5"/>' +
				'<circle cx="190" cy="' + (y + r) + '" r="' + (r - 10) + '" fill="none" stroke="rgba(70,45,25,.18)" stroke-width="1.2" stroke-dasharray="5 4"/>';
		} else {
			body = '<rect x="' + x + '" y="' + y + '" width="' + L + '" height="' + S + '" rx="3" fill="#dac19f" stroke="rgba(70,45,25,.3)" stroke-width="1.5"/>' +
				'<rect x="' + (x + 10) + '" y="' + (y + 10) + '" width="' + (L - 20) + '" height="' + (S - 20) + '" rx="2" fill="none" stroke="rgba(70,45,25,.18)" stroke-width="1.2" stroke-dasharray="5 4"/>';
		}
		return '<svg class="rnr-finder--sizesvg" viewBox="0 0 380 260" preserveAspectRatio="xMidYMid meet">' + body + '</svg>';
	}

	var imgCache = {};
	try { imgCache = JSON.parse(sessionStorage.getItem('rnrFinderImgs') || '{}'); } catch (e) { imgCache = {}; }

	function fetchOptionImage(opt, el) {
		if (imgCache[opt.key] !== undefined) {
			if (imgCache[opt.key]) applyImage(el, imgCache[opt.key]);
			return;
		}
		var url = '/search/suggest.json?q=' + encodeURIComponent(opt.query) +
			'&resources[type]=product&resources[limit]=1&resources[options][unavailable_products]=hide';
		fetch(url).then(function (r) { return r.json(); }).then(function (d) {
			var ps = d && d.resources && d.resources.results && d.resources.results.products;
			var src = '';
			if (ps && ps.length) {
				var pr = ps[0];
				src = (pr.featured_image && pr.featured_image.url) || pr.image || '';
			}
			imgCache[opt.key] = src || '';
			try { sessionStorage.setItem('rnrFinderImgs', JSON.stringify(imgCache)); } catch (e) {}
			if (src) applyImage(el, src);
		}).catch(function () {});
	}

	// Blur-up loading: a 40px CDN thumb renders instantly (blurred, scaled),
	// then the full-size image fades in over it.
	function sizedUrl(src, w) {
		if (/([?&])width=\d+/.test(src)) return src.replace(/([?&])width=\d+/, '$1width=' + w);
		return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
	}

	function applyImage(el, src) {
		if (!el || !el.isConnected || el.querySelector('img')) return;
		var tiny = document.createElement('img');
		tiny.className = 'rnr-finder--img-tiny';
		tiny.alt = '';
		tiny.src = sizedUrl(src, 40);
		var img = document.createElement('img');
		img.className = 'rnr-finder--img-full';
		img.alt = '';
		img.onload = function () { el.classList.add('has-image'); };
		img.src = sizedUrl(src, 560);
		el.appendChild(tiny);
		el.appendChild(img);
	}

	function mediaFor(opt) {
		if (overrides[opt.key]) {
			return '<span class="rnr-finder--media" data-media="' + opt.key + '"></span>';
		}
		if (opt.photo) {
			// A theme asset, not a CDN product image, so it is served at its
			// own size rather than through the ?width= resizer applyImage uses.
			// No loading="lazy": the cards are injected before the step has
			// been laid out, so Chrome defers them and then never re-checks
			// on a page that is never scrolled. Seven cards, above the fold.
			return '<span class="rnr-finder--media rnr-finder--media-photo has-image">' +
				'<img class="rnr-finder--img-full" alt="" decoding="async"' +
				' src="' + opt.photo + '"' +
				(opt.photoSm ? ' srcset="' + opt.photoSm + ' 600w, ' + opt.photo + ' 1200w" sizes="(min-width: 1024px) 260px, 45vw"' : '') +
				'></span>';
		}
		if (opt.w) {
			return '<span class="rnr-finder--media rnr-finder--media-svg">' + sizeSvg(opt) + '</span>';
		}
		if (opt.swatch) {
			return '<span class="rnr-finder--media rnr-finder--media-swatch"><span class="rnr-finder--swatch" style="background:' + opt.swatch + '"></span></span>';
		}
		return '<span class="rnr-finder--media" data-media="' + opt.key + '"></span>';
	}

	function render() {
		var step = steps[current];

		// progress dots
		var ph = '';
		steps.forEach(function (s, i) {
			var cls = 'rnr-finder--dot';
			if (i === current) cls += ' is-current';
			else if (selectedCount(s) > 0) cls += ' is-done';
			ph += '<span class="' + cls + '"></span>';
		});
		progEl.innerHTML = ph;

		// step body
		var h = '<h2 class="rnr-finder--step-title">' + step.title + '</h2>';
		if (step.hint) h += '<p class="rnr-finder--step-hint">' + step.hint + '</p>';
		h += '<div class="rnr-finder--options rnr-finder--options-' + step.key + '" role="group" aria-label="' + step.title + '">';
		step.options.forEach(function (o) {
			var on = !!picked[step.key][o.key];
			h += '<button type="button" class="rnr-finder--opt' + (on ? ' is-selected' : '') + '"' +
				' data-opt="' + o.key + '" aria-pressed="' + on + '">';
			h += mediaFor(o);
			h += '<span class="rnr-finder--opt-text">';
			h += '<span class="rnr-finder--opt-label">' + o.label + '</span>';
			if (o.sub) h += '<span class="rnr-finder--opt-sub">' + o.sub + '</span>';
			h += '</span>';
			h += '<span class="rnr-finder--tick" aria-hidden="true"><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg></span>';
			h += '</button>';
		});
		h += '</div>';
		stepEl.innerHTML = h;

		stepEl.querySelectorAll('.rnr-finder--opt').forEach(function (b) {
			b.addEventListener('click', function () { toggle(step, b.getAttribute('data-opt')); });
		});
		step.options.forEach(function (o) {
			var el = stepEl.querySelector('[data-media="' + o.key + '"]');
			if (!el || el.querySelector('img')) return;
			if (overrides[o.key]) applyImage(el, overrides[o.key]);
			else if (o.query) fetchOptionImage(o, el);
		});

		// sidebar summary
		var sh = '';
		steps.forEach(function (s, i) {
			var chips = Object.keys(picked[s.key]).map(function (k) {
				var o = optionByKey(s, k);
				return o ? '<em class="rnr-finder--chip">' + o.label + '</em>' : '';
			}).join('');
			sh += '<button type="button" class="rnr-finder--side-step' + (i === current ? ' is-current' : '') + '" data-jump="' + i + '">' +
				'<span class="rnr-finder--side-n">' + (i + 1) + '</span>' +
				'<span class="rnr-finder--side-body"><span class="rnr-finder--side-label">' + s.title + '</span>' +
				(chips ? '<span class="rnr-finder--side-chips">' + chips + '</span>' : '<span class="rnr-finder--side-none">' + (selectedCount(s) ? '' : (i < current ? 'Skipped' : '&mdash;')) + '</span>') +
				'</span></button>';
		});
		sideEl.innerHTML = sh;
		sideEl.querySelectorAll('[data-jump]').forEach(function (b) {
			b.addEventListener('click', function () { go(parseInt(b.getAttribute('data-jump'), 10)); });
		});

		// nav bar. Browse is always the filled primary; Skip is a secondary
		// outline that only appears when a skippable step is empty.
		backBtn.disabled = current === 0;
		var last = current === steps.length - 1;
		var any = selectedCount(step) > 0;
		skipBtn.style.display = (!last && step.skippable && !any) ? '' : 'none';
		nextBtn.textContent = last ? 'Browse your range' : 'Next';
		nextBtn.style.display = (!last && step.skippable && !any) ? 'none' : '';
		nextBtn.disabled = !last && !step.skippable && !any;
		browseA.style.display = last ? 'none' : '';
		browseA.setAttribute('href', buildUrl());
	}

	backBtn.addEventListener('click', function () { go(current - 1); });
	skipBtn.addEventListener('click', function () { go(current + 1); });
	nextBtn.addEventListener('click', function () {
		if (current === steps.length - 1) finish();
		else go(current + 1);
	});

	render();
})();
